import { ENVIRONMENT_INITIALIZER, makeEnvironmentProviders } from '@angular/core';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import { WishlistShareModalComponent } from './account/wishlist/share/wishlist-share-modal.component';
import { BasketAddConfirmationModal } from './basket/basket-add-confirmation-modal/basket-add-confirmation-modal.component';
import { MinibasketComponent } from './basket/minibasket/minibasket.component';
import { CmsImageZoomModalComponent } from './catalog/page/component/image-zoom-modal/image-zoom-modal.component';
import { CmsProductSizeGuideComponent } from './catalog/product/cms/product-size-guide/cms-product-size-guide.component';
import { PdpTrustMessagesModalComponent } from './catalog/product/pdp-trust-messages/pdp-trust-messages-modal.component';
import { ProductViewSeeInStoreModalComponent } from './catalog/product/see-in-store/modal/product-view-see-in-store-modal.component';
import { ProductViewSeeInStoreModalStoreDetailsComponent } from './catalog/product/see-in-store/modal/store-details/product-view-see-in-store-modal-store-details.component';
import { MadeToOrderInfoModalComponent } from './catalog/product/stock-levels/made-to-order-info-modal/made-to-order-info-modal.component';
import { ProductViewCareInformationModalComponent } from './catalog/product/view-care-information/modal/product-view-care-information-modal.component';
import { ProductViewDeliveryModalComponent } from './catalog/product/view-delivery/modal/product-view-delivery-modal.component';
import { ProductViewDimensionsAndDetailsModalComponent } from './catalog/product/view-dimensions-and-details/modal/product-view-dimensions-and-details-modal.component';
import { ProductViewDimensionsAndDetailsModalRightComponent } from './catalog/product/view-dimensions-and-details/modal/right/product-view-dimensions-and-details-modal-right.component';
import { ProductViewSamplesModalComponent } from './catalog/product/view-samples/modal/product-view-samples-modal.component';
import { ProductViewUpsellProductModalComponent } from './catalog/product/view-upsell-products/modal/item/product-view-upsell-product-modal.component';
import { ProductViewUpsellProductsModalComponent } from './catalog/product/view-upsell-products/modal/product-view-upsell-products-modal.component';
import { WarrantyAndReturnsModalComponent } from './catalog/product/view-warranty-and-returns/modal/product-view-warranty-and-returns-modal.component';
import { ProductReviewModalComponent } from './catalog/review/product-review-modal/product-review-modal.component';
import { CheckoutDeliveryInfoModalComponent } from './checkout/delivery/info-modal/checkout-delivery-info-modal.component';
import { ProtectionPlansInfoModalComponent } from './module/protection-plans/info-modal/protection-plans-info-modal.component';
import { UgcImageFormComponent } from './module/ugc-image/form/ugc-image-form.component';
import { V12RetailFinanceDetailsModalComponent } from './module/v12-retail-finance/details-modal/v12-retail-finance-details-modal.component';
import { V12RetailFinanceModalComponent } from './module/v12-retail-finance/from/modal/v12-retail-finance-from-modal.component';
import { OffCanvasSearchTrayModalComponent } from './search/ui/off-canvas-search-tray-modal.component';
import { NotificationModalComponent } from './ui/display/notification/notification.modal.component';
import { ProductListingFiltersModalComponent } from './ui/listing/product-listing-filters.modal.component';

const modals = [
    BasketAddConfirmationModal,
    ProductViewSeeInStoreModalComponent,
    ProductViewSeeInStoreModalStoreDetailsComponent,
    ProductViewDimensionsAndDetailsModalComponent,
    ProductViewDimensionsAndDetailsModalRightComponent,
    ProductViewUpsellProductModalComponent,
    WarrantyAndReturnsModalComponent,
    ProductReviewModalComponent,
    ProtectionPlansInfoModalComponent,
    UgcImageFormComponent,
    NotificationModalComponent,
    ProductListingFiltersModalComponent,
    WishlistShareModalComponent,
    MinibasketComponent,
    CmsImageZoomModalComponent,
    CmsProductSizeGuideComponent,
    PdpTrustMessagesModalComponent,
    ProductViewCareInformationModalComponent,
    ProductViewDeliveryModalComponent,
    ProductViewSamplesModalComponent,
    ProductViewUpsellProductModalComponent,
    CheckoutDeliveryInfoModalComponent,
    V12RetailFinanceDetailsModalComponent,
    V12RetailFinanceModalComponent,
    OffCanvasSearchTrayModalComponent,
    ProductViewUpsellProductsModalComponent,
    MadeToOrderInfoModalComponent
];

export const provideModals = () => {
    return makeEnvironmentProviders([
        {
            provide: ENVIRONMENT_INITIALIZER,
            useFactory: () => () => {
                return surviveTreeShaking(modals);
            },
            multi: true
        }
    ]);
};
